// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Products ────────────────────────────────────────────
   Reuses the workshops page's shared pieces (awk__toolbar,
   awk__status, awk__icon-btn, acard); only the shelf itself and
   the variant grid are particular to this page. */

.apr__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.apr__card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1.1rem;
}

.apr__card-img {
  flex: 0 0 auto;
  width: 66px;
  height: 66px;
  border-radius: 8px;
  overflow: hidden;
  background: #efeee8;
  display: grid;
  place-items: center;
}

.apr__card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.apr__card-noimg {
  color: #b4ada2;
  font-size: 1.4rem;
  display: grid;
  place-items: center;
}

.apr__card-main {
  flex: 1 1 auto;
  min-width: 0;
}

.apr__card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 1.02rem;
  margin: 0 0 0.3rem;
  color: #1e2a1e;
}

/* Two lines, then fade out — \`nowrap\` here is what used to force the whole
   page wider than the screen on a tablet. */
.apr__card-sum {
  font-size: 0.86rem;
  color: #55504a;
  margin: 0 0 0.3rem;
  max-width: 46rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.apr__card-meta {
  font-size: 0.8rem;
  color: #6b6258;
  margin: 0;
}

.apr__oos { color: #b91c1c; font-weight: 700; }

.awk__status--archived { background: rgba(107, 98, 88, 0.14); color: #6b6258; }

/* ── The editor ──
   Wider than the shared contact modal, which is \`width: min(420px, 90vw)\` —
   a max-width can't widen a width, so this sets the width itself. */
.apr__modal {
  width: min(760px, 94vw);
  max-height: 88vh;
  overflow-y: auto;
}

.apr__modal .ars__field { min-width: 0; }

.apr__modal input,
.apr__modal textarea,
.apr__modal select {
  max-width: 100%;
  box-sizing: border-box;
}

.apr__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.9rem;
}

.apr__section {
  border-top: 1px solid #e8e6df;
  margin-top: 1.1rem;
  padding-top: 0.9rem;
}

.apr__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.3rem;
}

.apr__section-head h4 {
  margin: 0;
  font-size: 0.95rem;
  color: #1e2a1e;
}

.apr__mini {
  padding: 0.32rem 0.7rem;
  font-size: 0.76rem;
}

.apr__hint {
  font-size: 0.78rem;
  color: #6b6258;
  margin: 0 0 0.6rem;
}

.apr__empty {
  font-size: 0.84rem;
  color: #8a8279;
  font-style: italic;
  margin: 0.3rem 0 0.6rem;
}

/* ── Variants ──
   colour · swatch · size · sku · price · stock · remove */
.apr__variants {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.apr__variant {
  display: grid;
  grid-template-columns: 1.3fr 2.6rem 1fr 1.2fr 0.9fr 0.8fr 2rem;
  gap: 0.4rem;
  align-items: center;
}

.apr__variant .arb__form-input {
  padding: 0.42rem 0.55rem;
  font-size: 0.83rem;
  min-width: 0;
}

.apr__colour {
  width: 100%;
  height: 34px;
  padding: 2px;
  border: 1px solid #ddd9d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}

/* ── Photos ── */
.apr__images {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
}

.apr__image {
  position: relative;
  width: 86px;
  height: 86px;
  border-radius: 8px;
  overflow: hidden;
  background: #efeee8;
  border: 1px solid #e3e0d8;
}

.apr__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.apr__image button {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: none;
  border-radius: 50%;
  background: rgba(20, 20, 18, 0.66);
  color: #fff;
  cursor: pointer;
  font-size: 0.8rem;
  line-height: 1;
}

.apr__image button:hover { background: #b91c1c; }

.apr__image-main {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 1px 6px;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  background: rgba(var(--admin-rust-rgb), 0.92);
  color: #fff;
}

/* ── Narrower screens ──
   The variant row becomes two columns rather than seven, so nothing
   is squeezed to an unusable width. */
@media (max-width: 900px) {
  .apr__row { grid-template-columns: 1fr; }

  .apr__variant {
    grid-template-columns: 1fr 1fr;
    gap: 0.4rem 0.5rem;
    padding: 0.6rem;
    border: 1px solid #e8e6df;
    border-radius: 8px;
    background: #fbfaf7;
  }

  .apr__variant .apr__colour { grid-column: span 1; }

  .apr__variant .awk__icon-btn {
    grid-column: 1 / -1;
    justify-self: end;
  }
}

@media (max-width: 640px) {
  .apr__card {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .apr__card-main { flex: 1 1 60%; }

  .apr__card .awk__card-actions {
    flex: 1 1 100%;
    justify-content: flex-end;
  }

  .apr__variant { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminProducts.css"],"names":[],"mappings":"AAAA;;;kDAGkD;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;4CAC4C;AAC5C;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,YAAY,cAAc,EAAE,gBAAgB,EAAE;;AAE9C,yBAAyB,mCAAmC,EAAE,cAAc,EAAE;;AAE9E;;oEAEoE;AACpE;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B,YAAY,EAAE;;AAExC;;;EAGE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;0DAC0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;;sCAEsC;AACtC;EACE,YAAY,0BAA0B,EAAE;;EAExC;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,6BAA6B,mBAAmB,EAAE;;EAElD;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA,kBAAkB,aAAa,EAAE;;EAEjC;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA,gBAAgB,0BAA0B,EAAE;AAC9C","sourcesContent":["/* ── Products ────────────────────────────────────────────\n   Reuses the workshops page's shared pieces (awk__toolbar,\n   awk__status, awk__icon-btn, acard); only the shelf itself and\n   the variant grid are particular to this page. */\n\n.apr__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.apr__card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.9rem 1.1rem;\n}\n\n.apr__card-img {\n  flex: 0 0 auto;\n  width: 66px;\n  height: 66px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #efeee8;\n  display: grid;\n  place-items: center;\n}\n\n.apr__card-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.apr__card-noimg {\n  color: #b4ada2;\n  font-size: 1.4rem;\n  display: grid;\n  place-items: center;\n}\n\n.apr__card-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.apr__card-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 1.02rem;\n  margin: 0 0 0.3rem;\n  color: #1e2a1e;\n}\n\n/* Two lines, then fade out — `nowrap` here is what used to force the whole\n   page wider than the screen on a tablet. */\n.apr__card-sum {\n  font-size: 0.86rem;\n  color: #55504a;\n  margin: 0 0 0.3rem;\n  max-width: 46rem;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.apr__card-meta {\n  font-size: 0.8rem;\n  color: #6b6258;\n  margin: 0;\n}\n\n.apr__oos { color: #b91c1c; font-weight: 700; }\n\n.awk__status--archived { background: rgba(107, 98, 88, 0.14); color: #6b6258; }\n\n/* ── The editor ──\n   Wider than the shared contact modal, which is `width: min(420px, 90vw)` —\n   a max-width can't widen a width, so this sets the width itself. */\n.apr__modal {\n  width: min(760px, 94vw);\n  max-height: 88vh;\n  overflow-y: auto;\n}\n\n.apr__modal .ars__field { min-width: 0; }\n\n.apr__modal input,\n.apr__modal textarea,\n.apr__modal select {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.apr__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.9rem;\n}\n\n.apr__section {\n  border-top: 1px solid #e8e6df;\n  margin-top: 1.1rem;\n  padding-top: 0.9rem;\n}\n\n.apr__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.3rem;\n}\n\n.apr__section-head h4 {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #1e2a1e;\n}\n\n.apr__mini {\n  padding: 0.32rem 0.7rem;\n  font-size: 0.76rem;\n}\n\n.apr__hint {\n  font-size: 0.78rem;\n  color: #6b6258;\n  margin: 0 0 0.6rem;\n}\n\n.apr__empty {\n  font-size: 0.84rem;\n  color: #8a8279;\n  font-style: italic;\n  margin: 0.3rem 0 0.6rem;\n}\n\n/* ── Variants ──\n   colour · swatch · size · sku · price · stock · remove */\n.apr__variants {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.apr__variant {\n  display: grid;\n  grid-template-columns: 1.3fr 2.6rem 1fr 1.2fr 0.9fr 0.8fr 2rem;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.apr__variant .arb__form-input {\n  padding: 0.42rem 0.55rem;\n  font-size: 0.83rem;\n  min-width: 0;\n}\n\n.apr__colour {\n  width: 100%;\n  height: 34px;\n  padding: 2px;\n  border: 1px solid #ddd9d0;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n}\n\n/* ── Photos ── */\n.apr__images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.6rem;\n}\n\n.apr__image {\n  position: relative;\n  width: 86px;\n  height: 86px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #efeee8;\n  border: 1px solid #e3e0d8;\n}\n\n.apr__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.apr__image button {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 20px;\n  height: 20px;\n  display: grid;\n  place-items: center;\n  border: none;\n  border-radius: 50%;\n  background: rgba(20, 20, 18, 0.66);\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.8rem;\n  line-height: 1;\n}\n\n.apr__image button:hover { background: #b91c1c; }\n\n.apr__image-main {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  padding: 1px 6px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  background: rgba(var(--admin-rust-rgb), 0.92);\n  color: #fff;\n}\n\n/* ── Narrower screens ──\n   The variant row becomes two columns rather than seven, so nothing\n   is squeezed to an unusable width. */\n@media (max-width: 900px) {\n  .apr__row { grid-template-columns: 1fr; }\n\n  .apr__variant {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.4rem 0.5rem;\n    padding: 0.6rem;\n    border: 1px solid #e8e6df;\n    border-radius: 8px;\n    background: #fbfaf7;\n  }\n\n  .apr__variant .apr__colour { grid-column: span 1; }\n\n  .apr__variant .awk__icon-btn {\n    grid-column: 1 / -1;\n    justify-self: end;\n  }\n}\n\n@media (max-width: 640px) {\n  .apr__card {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .apr__card-main { flex: 1 1 60%; }\n\n  .apr__card .awk__card-actions {\n    flex: 1 1 100%;\n    justify-content: flex-end;\n  }\n\n  .apr__variant { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
